import { cageScopedSearch, QUERY_SELECTED_FISH_GROUP_ID } from '@/contexts/cage-filter-context';

/**
 * The pen dashboard a group's detail dialog links to: the group's last pen, pinned to the group
 * with `fg`. Without `fg` the pen page shows whoever is in the pen today, and an empty pen sends
 * the reader back to the location, so a closed group could never be opened from the board.
 *
 * The board's own params stay on the board; the pen-scoped ones (`cageScopedSearch`) follow, as
 * they do between pen pages, and the group's `fg` replaces any already in the URL.
 */
export function groupDashboardPath(
    boardPathname: string,
    boardSearch: string,
    penId: number,
    fishGroupId: number
): string {
    const search = new URLSearchParams(cageScopedSearch(boardSearch));
    search.set(QUERY_SELECTED_FISH_GROUP_ID, String(fishGroupId));
    const penPath = boardPathname.replace(/\/fish-groups\/?$/, `/pen/${penId}`);
    return `${penPath}?${search.toString()}`;
}
